import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="0 0 48 48" fill="none"><path fill="#25ACD6" fill-rule="evenodd" d="M3.286 7.074c.886 5.158 9.4 10.328 13.546 12.269-2.84 3.38-2.954 10.536 1.221 13.801 3.34 2.613 3.493 5.254 3.238 7.782-2.045-4.998-5.037-6.769-6.958-7.782-.313 1.42.227 3.115.681 3.834-4.566-2.317-8.292-9.854-8.292-12.495.96 1.195 2.13 1.373 2.707 1.46l.104.016c0-1.164-.198-2.669-2.982-5.367-3.063-2.969-4.401-8.974-3.265-13.518Zm27.437 18.772a6.56 6.56 0 1 1-13.12 0 6.56 6.56 0 0 1 13.12 0Zm.558-6.503c4.146-1.94 12.66-7.111 13.546-12.269 1.136 4.544-.203 10.549-3.266 13.518-2.783 2.698-2.982 4.203-2.982 5.368l.104-.017c.578-.087 1.747-.265 2.708-1.46 0 2.64-3.726 10.178-8.293 12.495.455-.72.994-2.414.682-3.834-1.922 1.013-4.913 2.784-6.958 7.782-.255-2.528-.102-5.169 3.238-7.782 4.174-3.265 4.06-10.422 1.22-13.801Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
